import { Component, Input } from '@angular/core';

@Component({
  selector: 'payarc-page-header',
  template: `
    <div class="pa-head">
      <div class="pa-head__text">
        <h2 class="pa-head__title" [attr.id]="titleId">{{ title }}</h2>
        <p class="pa-head__sub" *ngIf="subtitle">{{ subtitle }}</p>
      </div>
      <div class="pa-head__actions"><ng-content></ng-content></div>
    </div>`,
  styleUrls: ['./payarc-page-header.component.css'],
  standalone: false
})
export class PayarcPageHeaderComponent {
  @Input() title = '';
  @Input() subtitle?: string;
  @Input() titleId?: string;
}
